export const carPositionOption = {
    height: 'auto',
    calcHeight: 80,
    tip: false,
    addBtn: false,
    delBtn: false,
    searchShow: true,
    searchMenuSpan: 6,
    labelWidth: 150,
    border: true,
    index: true,
    selection: false,
    viewBtn: false,
    dialogType: 'dialog',
    dialogClickModal: false,
    rowKey: "index",
    column: [{
            label: "产品名称",
            prop: "productName",
            type: "input",
            search: false,
            searchOrder: 1000,
            span: 24,
            disabled: true,
        },
        {
            label: "租付类型",
            prop: "type",
            type: "select",
            search: false,
            display: true,
            span: 24,
            dicData: [{
                    label: "先付后租",
                    value: 0
                },
                {
                    label: "先租后付",
                    value: 1
                }
            ]
        }
    ],
}